import { useContext } from "react";
import { PageContext } from "../store/context/context";

import Home from "./Home";
import AboutMe from "./AboutMe";
import ContactMe from "./ContactMe";

function Page() {
  const pageCtx = useContext(PageContext);

  const routes = {
    home: { content: <Home /> },
    aboutMe: { content: <AboutMe /> },
    contactMe: { content: <ContactMe /> },
  };

  return <> {pageCtx.page ? routes[pageCtx.page].content : <Home />} </>;
}
export default Page;
